import { GlobalButton } from './GlobalButton';
import type { ViewLayoutMode } from '../hooks/useViewLayoutMode';

type ViewLayoutToggleProps = {
  mode: ViewLayoutMode;
  onToggle: () => void;
};

/** Two stacked panels — represents the stacked layout. */
function StackedLayoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="4.5" width="17" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.75" />
      <rect x="3.5" y="13.5" width="17" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.75" />
    </svg>
  );
}

/** A panel with a segmented tab bar — represents the tabbed layout. */
function TabbedLayoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="5.5" width="17" height="14" rx="1.75" stroke="currentColor" strokeWidth="1.75" />
      <path d="M3.5 10h17" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path d="M9 5.5V10M14 5.5V10" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

/**
 * Toolbar button that switches the current view between the stacked layout and a
 * tabbed layout. Like the theme toggle, it shows the icon for the layout the user
 * would switch *to*.
 */
export function ViewLayoutToggle({ mode, onToggle }: ViewLayoutToggleProps) {
  const isTabs = mode === 'tabs';
  const label = isTabs ? 'Switch to stacked layout' : 'Switch to tabbed layout';

  return (
    <GlobalButton
      type="button"
      variant="secondary"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={isTabs}
      title={label}
      icon={isTabs ? <StackedLayoutIcon /> : <TabbedLayoutIcon />}
    >
      Layout
    </GlobalButton>
  );
}
